import React from 'react';
import FormFieldSet from '../FormFieldSet';
import FloatingLabel from '../FloatingLabel';
import MapComponent from '../../../map/components/MapComponent';
import { MapMarker } from '../../../map/types';
import PlaceAutocomplete from './PlaceAutocomplete';
import { APIProvider } from '@vis.gl/react-google-maps';

interface AddressValidatorProps {
    handleAddressChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
    marker: MapMarker | null;
    handlePlaceSelect: (place: google.maps.places.Place) => void;
    display?: boolean;
}

const AddressValidator: React.FC<AddressValidatorProps> = ({ handleAddressChange, marker, handlePlaceSelect, display = false }) => {
    return (
        <FormFieldSet legend="Location">
            <div className={`grid grid-cols-1 grid-rows-5 gap-4`}>
                { !display &&<FloatingLabel className="col-span-1 row-span-1">
                    <span>Address</span>
                    <APIProvider apiKey={'AIzaSyAjSExMPaf4YI1UCsnmfBNWsZsgvz7Mb04'}>
                        <PlaceAutocomplete handleAddressChange={handleAddressChange} handlePlaceSelect={handlePlaceSelect} />
                    </APIProvider>
                </FloatingLabel> }

                <div className="col-span-1 row-span-4">
                    <MapComponent markers={marker ? [marker] : []} isLoading={false} enableControls={false} />
                </div>
            </div>
        </FormFieldSet>
    );
};

export default AddressValidator;